import React from "react";
import { Col, Row } from "react-bootstrap";

import SelectField from "../selectField/SelectField";
import { customerConstants } from "../../../constants";
import ExpirationDateInput from "./ExpirationDateInput";
import { getIsShowCustomerScanButton } from "../../utility";
import InputTextField from "../inputTextField/InputTextField";
import DateOfBirthInput from "../datePickerDropDown/DateOfBirthInput";
import PhoneInputField from "../phoneInputField/PhoneInputField";

const PersonalInformation = (props) => {
  const {
    values,
    setFieldValue,
    setIsShowScanButton = () => {},
    allowCountries = [],
  } = props;

  const handleIdTypeChange = (value) => {
    setIsShowScanButton(getIsShowCustomerScanButton(value));
  };

  return (
    <Row className="p-0">
      <p className="form-portion-heading">Personal Information</p>
      <Col md={6} className="mb-3 ">
        <InputTextField
          name="firstName"
          label="First Name"
          placeHolder="First Name"
        />
      </Col>
      <Col md={6} className="mb-3 ">
        <InputTextField
          name="lastName"
          label="Last Name"
          placeHolder="Last Name"
        />
      </Col>
      <Col md={6} className="mb-3 ">
        <InputTextField name="email" label="Email" placeHolder="Email" />
      </Col>
      <Col md={6} className="mb-3">
        <PhoneInputField
          name="mobile"
          label="Phone Number"
          defaultCountry={values.countryCode}
          countries={allowCountries}
        />
      </Col>
      <Col md={6}>
        <SelectField
          label="ID Type"
          name="driverLicenseIdType"
          placeHolder={"Select ID Type"}
          options={customerConstants.ID_TYPES}
          isSearchable={false}
          onChangeValue={handleIdTypeChange}
        />
      </Col>
      <Col md={6} className="mb-3  ">
        <InputTextField
          name="driverLicense"
          label="ID Number"
          placeHolder="ID Number"
        />
      </Col>
      <Col md={6}>
        <DateOfBirthInput
          value={values.dateOfBirth}
          name={"dateOfBirth"}
          setFieldValue={setFieldValue}
        />
      </Col>
      <Col md={6}>
        <ExpirationDateInput
          value={values.expirationDate}
          name={"expirationDate"}
          setFieldValue={setFieldValue}
        />
      </Col>
    </Row>
  );
};

export default PersonalInformation;
